import { Breakpoints, DesignTokenSizeEnum, Layout } from '@volkswagen-onehub/components-core';
import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

export interface StyledWrapperProps {
  paddingTop?: DesignTokenSizeEnum;
  paddingBottom?: DesignTokenSizeEnum;
}

const StyledWrapper = styled.div<StyledWrapperProps>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.size.static350};
  ${(props) => props.paddingTop && `padding-top: ${props.theme.size[props.paddingTop]};`}
  ${(props) => props.paddingBottom && `padding-bottom: ${props.theme.size[props.paddingBottom]};`}
`;

export interface FieldsGroupProps extends StyledWrapperProps {
  children?: ReactNode;
}

export function FieldsGroup({ paddingTop, paddingBottom, children }: FieldsGroupProps): ReactElement {
  return (
    <Layout
      appearance={{
        [Breakpoints.default]: [{ name: 'a', columns: 24 }],
        [Breakpoints.b960]: [{ name: 'a', columns: 24 }],
        [Breakpoints.b1280]: [{ name: 'a', columns: 24 }],
        [Breakpoints.b2560]: [{ name: 'a', columns: 24 }],
      }}
      allowOverflowingContent>
      <StyledWrapper paddingTop={paddingTop} paddingBottom={paddingBottom}>
        {children}
      </StyledWrapper>
    </Layout>
  );
}
